import { memo } from 'react';
import colours from './colours';
import GenericIcon from './GenericIcon';

export default memo(({ direction, ...params }) => (
  <GenericIcon {...params} transform={`scale(1, ${direction === 'up' ? -1 : 1})`}>
    <path d="M8 10L12 14L16 10H8Z" fill={colours.get(params.colour || 'grey-6')} />
  </GenericIcon>
));
